import React, { useState, useMemo, useCallback, useEffect } from "react";
import BlogCard from "./components/BlogCard";
import Pagination from "./components/Pagination";
import BlogHeader from "./components/BlogsHeader";
import "./components/blog.style.css";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import { blogArray } from "../../blog";
import { Helmet } from "react-helmet";
const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Blog",
      "@id": "https://hirestar.io/blogs#blog",
      name: "HireStar.io Blogs",
      url: "https://hirestar.io/blogs",
      description:
        "Discover expert blogs and insights on background verification, employee screening, due diligence, and cutting-edge FinTech solutions to help you hire with confidence.",
      publisher: {
        "@type": "Organization",
        name: "HireStar.io",
        url: "https://hirestar.io",
      },
    },
    {
      "@type": "BlogPosting",
      "@id":
        "https://hirestar.io/blogs/top-background-verification-companies-hyderabad",
      headline: "Leading Background Verification Companies in Hyderabad",
      url: "https://hirestar.io/blogs/leading-employee-background-verification-companies-in-hyderabad",
      image:
        "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/hyderabad_img.jpg",
      datePublished: "2025-05-15T08:00:00+05:30",
      dateModified: "2025-05-15T08:00:00+05:30",
      author: {
        "@type": "Person",
        name: "HireStar.io Team",
      },
      publisher: {
        "@type": "Organization",
        name: "HireStar.io",
        url: "https://hirestar.io",
      },
      description:
        "An overview of the leading background verification companies operating in Hyderabad, highlighting their services and specialties.",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id":
          "https://hirestar.io/blogs/leading-employee-background-verification-companies-in-hyderabad",
      },
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://hirestar.io/blogs#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: "https://hirestar.io/blogs",
        },
      ],
    },
  ],
};

const BlogsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const [filteredBlogsArray, setFilteredBlogsArray] = useState(blogArray); // State for filtered blogs
  const [searchTimeout, setSearchTimeout] = useState(null); // State for debounce timeout
  // const [cityPageBlogs, setCityPageBlogs] = useState(cityBlogArray);

  const blogsPerPage = 9; // Set the number of blogs per page

  // Calculate the total number of pages
  const totalPages = useMemo(() => {
    return Math.ceil(filteredBlogsArray.length / blogsPerPage);
  }, [filteredBlogsArray.length, blogsPerPage]);
  // console.log("line 21",cityBlogArray)

  // Get the blogs for the current page
  const getCurrentBlogs = () => {
    const start = (currentPage - 1) * blogsPerPage;
    const end = start + blogsPerPage;
    return filteredBlogsArray.slice(start, end);
  };

  // console.log(blogArray)

  // Handle input change with debounce
  const handleSearch = useCallback((e) => {
    const value = e.target.value;
    setInputValue(value);
    // Only filter after a delay when `value` changes
    setSearchTimeout(value);
  }, []);

  useEffect(() => {
    // Only run the filter if there’s a non-empty search term
    if (searchTimeout) {
      const timeout = setTimeout(() => {
        const filteredBlogs = blogArray.filter((blog) =>
          blog.title.toLowerCase().includes(searchTimeout.toLowerCase())
        );
        setFilteredBlogsArray(filteredBlogs);
      }, 300); // Adjust the delay as needed

      return () => clearTimeout(timeout); // Clear timeout on unmount
    } else {
      // If searchTimeout is empty, show all blogs or handle it as needed
      setFilteredBlogsArray(blogArray);
    }
  }, [searchTimeout, blogArray]);
  // console.log(JSON.stringify(jsonLdData));
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Hirestar.io Blogs | Insights on Identity Verification & Compliance
        </title>
        <meta
          name="description"
          content="Stay updated with Hirestar.io's latest blogs covering identity verification, background screening, compliance, and digital onboarding solutions across various industries."
        />
        <meta
          name="keywords"
          content="Hirestar.io blogs, identity verification insights, background screening articles, compliance updates, digital onboarding, industry verification trends, blockchain based background verification, AI in background verification"
        />
        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />

        <meta property="og:title" content="Blogs" />

        <meta name="robots" content="index, follow" />
        <meta
          property="og:description"
          content="Stay updated with Hirestar.io's latest blogs covering identity verification, background screening, compliance, and digital onboarding solutions across various industries."
        />
        <meta property="og:url" content="https://hirestar.io/blogs" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/icon.jpeg"
        />
        <meta property="og:image:type" content="image/png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Hirestar.io Blogs | Insights on Identity Verification & Compliance"
        />
        <meta
          name="twitter:description"
          content="Stay informed with Hirestar.io's latest blogs on identity verification, background screening, and compliance solutions."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/icon.jpeg"
        />
      </Helmet>
      {/* Header */}
      <BlogHeader handleSearch={handleSearch} inputValue={inputValue} />
      {/* center this div */}
      <div
        className="max-w-5xl relative top-32 mx-auto  px-4 sm:px-6 lg:px-8 "
        id="my-section"
      >
        {/* Blogs component */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-8">
          {getCurrentBlogs().map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
        {/* {currentPage === 1 && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-8">
        {cityBlogArray.map((blog, idx) => (<CityBlogCard key={idx} blog={blog} />))}
        </div>} */}
        {/* Pagination component */}
        <div className="flex justify-center mb-20">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </div>
  );
};

export default BlogsPage;
